(function () {
  'use strict';

  if (window.MrMapleSearchIntelligence) return;

  var SEARCH_PAGE_CLASS = 'template-search';
  var MIN_QUERY_LENGTH = 4;
  var indexPromise = null;
  var suggestionCache = new Map();

  function cleanTitle(value) {
    return String(value || '')
      .replace(/^(?:FOR\s+)?PICK\s*UP\s+ONLY\s*\|\s*/gi, '')
      .replace(/\s*\|\s*DOES NOT SHIP\s*$/gi, '')
      .replace(/DOES NOT SHIP\s*$/gi, '')
      .trim();
  }

  function normalizeText(value) {
    return cleanTitle(value)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’‘]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/×/g, ' x ')
      .replace(/&/g, ' and ')
      .replace(/[^a-zA-Z0-9'"\s-]+/g, ' ')
      .replace(/['"]/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getTokens(value) {
    return normalizeText(value)
      .split(' ')
      .filter(function (token) {
        return token && token.length >= 2;
      });
  }

  function getSpellIndexUrl() {
    return (
      (window.Theme && window.Theme.routes && window.Theme.routes.search_spell_index_url) ||
      window.MRMAPLE_SEARCH_SPELL_INDEX_URL ||
      ''
    );
  }

  function getSearchUrl(query) {
    var baseUrl = (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
    return baseUrl
      + '?q=' + encodeURIComponent(query)
      + '&options%5Bprefix%5D=last'
      + '&options%5Bunavailable_products%5D=show'
      + '&sort_by=relevance';
  }

  function getRankedSearchPageUrl() {
    if (!document.body || !document.body.classList.contains(SEARCH_PAGE_CLASS)) return '';

    var url;
    try {
      url = new URL(window.location.href);
    } catch (error) {
      return '';
    }

    var query = String(url.searchParams.get('q') || '').trim();
    if (!query) return '';

    var unavailableProductsKey = 'options[unavailable_products]';
    var hasUnavailableProducts = url.searchParams.get(unavailableProductsKey) === 'show';
    var hasRelevanceSort = url.searchParams.get('sort_by') === 'relevance';
    if (hasUnavailableProducts && hasRelevanceSort) return '';

    url.searchParams.set(unavailableProductsKey, 'show');
    url.searchParams.set('sort_by', 'relevance');

    return url.pathname + url.search + url.hash;
  }

  function normalizeSearchPageUrl() {
    var rankedUrl = getRankedSearchPageUrl();
    if (!rankedUrl) return false;

    window.location.replace(rankedUrl);
    return true;
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;

    var spellIndexUrl = getSpellIndexUrl();
    if (!spellIndexUrl) {
      return Promise.resolve({ e: [] });
    }

    indexPromise = fetch(spellIndexUrl, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Search spell index unavailable');
        }

        return response.json();
      })
      .catch(function () {
        indexPromise = null;
        return { e: [] };
      });

    return indexPromise;
  }

  function boundedLevenshtein(left, right, maxDistance) {
    if (left === right) return 0;
    if (!left || !right) return Math.max(left.length, right.length);
    if (Math.abs(left.length - right.length) > maxDistance) return maxDistance + 1;

    var previous = new Array(right.length + 1);
    var current = new Array(right.length + 1);
    var index;

    for (index = 0; index <= right.length; index += 1) {
      previous[index] = index;
    }

    for (var leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
      current[0] = leftIndex;
      var rowMin = current[0];

      for (var rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
        var substitutionCost = left.charAt(leftIndex - 1) === right.charAt(rightIndex - 1) ? 0 : 1;
        current[rightIndex] = Math.min(
          previous[rightIndex] + 1,
          current[rightIndex - 1] + 1,
          previous[rightIndex - 1] + substitutionCost,
        );

        if (current[rightIndex] < rowMin) {
          rowMin = current[rightIndex];
        }
      }

      if (rowMin > maxDistance) return maxDistance + 1;

      for (index = 0; index <= right.length; index += 1) {
        previous[index] = current[index];
      }
    }

    return previous[right.length];
  }

  function scoreToken(queryToken, candidateToken) {
    if (!queryToken || !candidateToken) return 0;
    if (queryToken === candidateToken) return 1;

    if (
      candidateToken.indexOf(queryToken) === 0 ||
      queryToken.indexOf(candidateToken) === 0
    ) {
      return 0.92 - Math.min(Math.abs(candidateToken.length - queryToken.length), 6) * 0.03;
    }

    var maxLength = Math.max(queryToken.length, candidateToken.length);
    var maxDistance = Math.max(2, Math.ceil(maxLength * 0.35));
    var distance = boundedLevenshtein(queryToken, candidateToken, maxDistance);

    if (distance > maxDistance) return 0;

    return Math.max(0, 1 - distance / maxLength);
  }

  function scorePhrase(queryNormalized, queryTokens, phraseNormalized) {
    if (!phraseNormalized) return 0;
    if (queryNormalized === phraseNormalized) return 1;

    var phraseTokens = phraseNormalized.split(' ').filter(Boolean);
    if (!queryTokens.length || !phraseTokens.length) return 0;

    var totalScore = 0;
    var matchedTokens = 0;

    queryTokens.forEach(function (queryToken) {
      var bestTokenScore = 0;

      phraseTokens.forEach(function (candidateToken) {
        var tokenScore = scoreToken(queryToken, candidateToken);
        if (tokenScore > bestTokenScore) {
          bestTokenScore = tokenScore;
        }
      });

      totalScore += bestTokenScore;
      if (bestTokenScore >= 0.72) {
        matchedTokens += 1;
      }
    });

    var averageScore = totalScore / queryTokens.length;
    var coverageScore = matchedTokens / queryTokens.length;
    var substringBonus = 0;

    if (
      phraseNormalized.indexOf(queryNormalized) !== -1 ||
      queryNormalized.indexOf(phraseNormalized) !== -1
    ) {
      substringBonus = 0.08;
    }

    return Math.min(1, averageScore * 0.75 + coverageScore * 0.25 + substringBonus);
  }

  function scoreEntry(queryNormalized, queryTokens, entry) {
    var bestScore = 0;

    (entry.p || []).forEach(function (phrase) {
      var phraseScore = scorePhrase(queryNormalized, queryTokens, phrase);
      if (phraseScore > bestScore) {
        bestScore = phraseScore;
      }
    });

    return bestScore;
  }

  function hasProductMatches(root) {
    return Boolean(root && root.querySelector('.search-flydown--product-list-item'));
  }

  function correctionScore(query, phrase) {
    var left = query.split(' ');
    var right = normalizeText(phrase).split(' ');
    // A partial species or cultivar must not become an arbitrary longer name.
    if (left.length !== right.length) return 0;
    var sum = 0;
    for (var i = 0; i < left.length; i += 1) {
      if (left[i] === right[i]) { sum += 1; continue; }
      var length = Math.max(left[i].length, right[i].length);
      if (length < 4) return 0;
      var distance = boundedLevenshtein(left[i], right[i], 2);
      var score = 1 - distance / length;
      if (distance > 2 || score < 0.7) return 0;
      sum += score;
    }
    return sum / left.length;
  }

  async function findCatalogMatch(query) {
    var normalized = normalizeText(query);
    if (normalized.length < MIN_QUERY_LENGTH) return null;
    if (suggestionCache.has(normalized)) return suggestionCache.get(normalized);
    var index = await loadIndex();
    // Version 2 carries current publication identities and explicit cultivar labels.
    if (index.version !== 2) return null;
    var candidates = new Map();
    (index.e || []).forEach(function (entry) {
      [entry.l].concat(entry.c || []).forEach(function (phrase) {
        var key = normalizeText(phrase);
        var score = correctionScore(normalized, key);
        if (score < 0.84) return;
        var candidate = candidates.get(key);
        if (!candidate) {
          candidate = { query: phrase, label: phrase, score: score, exact: key === normalized, products: [] };
          candidates.set(key, candidate);
        }
        (entry.products || []).forEach(function (product) {
          if (!candidate.products.some(function (existing) { return existing.id === product.id; })) {
            candidate.products.push({ id: product.id, h: product.h, title: entry.l });
          }
        });
      });
    });
    var ranked = Array.from(candidates.values()).sort(function (a, b) { return b.score - a.score; });
    var best = ranked[0];
    var match = best && (best.exact || !ranked[1] || best.score - ranked[1].score >= 0.06) ? best : null;
    // Bound autocomplete session memory, including negative queries.
    if (suggestionCache.size >= 100) suggestionCache.delete(suggestionCache.keys().next().value);
    suggestionCache.set(normalized, match);
    return match;
  }

  async function findSuggestion(query) {
    var match = await findCatalogMatch(query);
    return match && !match.exact ? match : null;
  }

  var SEARCH_CARD_SELECTOR = '[data-search-product-card], [data-product-compare-card], [data-wishlist-card]';

  function hasRelevantProductMatches(scope, query) {
    if (!scope) return false;
    var normalized = normalizeText(query);
    var tokens = getTokens(query);
    if (!tokens.length) return false;
    return Array.from(scope.querySelectorAll('[data-product-title], .search-flydown--product-title')).some(function (card) {
      var title = getDatasetValue(card, 'productTitle') || card.textContent;
      var phrases = [title, getDatasetValue(card, 'productType'),
        getDatasetValue(card, 'productTags'), getDatasetValue(card, 'productHandle')].map(normalizeText);
      // This is a warning heuristic, not the stricter cultivar correction gate.
      // Category searches often share only one meaningful word with a full title.
      var words = new Set(phrases.join(' ').split(' '));
      return tokens.some(function (token) { return token.length > 1 && words.has(token); }) ||
        scoreEntry(normalized, tokens, { p: phrases }) >= 0.84;
    });
  }

  async function getCatalogRecovery(query, scope, signal) {
    var match = await findCatalogMatch(query);
    if (!match || (signal && signal.aborted)) return null;
    var present = new Set(Array.from(scope.querySelectorAll('[data-product-handle]')).map(function (card) {
      return card.dataset.productHandle;
    }));
    var candidates = match.products.filter(function (product) { return !present.has(product.h); });
    // Prefer shippable listings, while keeping distinct product identities intact.
    candidates.sort(function (a, b) { return Number(/pick.?up/.test(a.h)) - Number(/pick.?up/.test(b.h)); });
    var products = await Promise.all(candidates.slice(0, 4).map(async function (expected) {
      if (!/^[\p{L}\p{M}\p{N}_-]+$/u.test(expected.h)) return null;
      var controller = new AbortController();
      var abort = function () { controller.abort(); };
      if (signal) signal.addEventListener('abort', abort, { once: true });
      if (signal && signal.aborted) abort();
      var timeout = setTimeout(abort, 5000);
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var response = await fetch(root + 'products/' + encodeURIComponent(expected.h) + '?view=search-match', {
          credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: controller.signal,
        });
        if (!response.ok) return null;
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var hidden = Array.from(doc.querySelectorAll('meta[name]')).some(function (meta) {
          return /^(robots|googlebot)$/i.test(meta.getAttribute('name')) && /noindex/i.test(meta.getAttribute('content') || '');
        });
        if (hidden || /noindex/i.test(response.headers.get('x-robots-tag') || '')) return null;
        var payload = doc.querySelector('[data-search-catalog-product]');
        if (!payload) return null;
        var product = JSON.parse(payload.textContent);
        var publishedAt = Date.parse(product.published_at);
        if (String(product.id) !== String(expected.id) || product.handle !== expected.h ||
          normalizeText(product.title) !== normalizeText(expected.title) || !Number.isFinite(publishedAt) || publishedAt > Date.now()) return null;
        return product;
      } catch (error) {
        return null;
      } finally {
        clearTimeout(timeout);
        if (signal) signal.removeEventListener('abort', abort);
      }
    }));
    return { match: match, products: products.filter(Boolean) };
  }

  function appendCatalogLinks(scope, recovery, query, page) {
    if (!scope || !recovery || !recovery.products.length) return false;
    var previous = scope.querySelector('[data-search-catalog-matches]');
    if (previous) previous.remove();
    var panel = document.createElement('div');
    panel.className = page ? 'mm-search-page-suggestion' : 'mm-search-suggestion';
    panel.setAttribute('data-search-catalog-matches', '');
    var title = document.createElement('p');
    title.className = page ? 'mm-search-page-suggestion__title' : 'mm-search-suggestion__text';
    title.textContent = recovery.match.exact ? 'Matching products' : 'Closest name matches for “' + query + '”';
    panel.appendChild(title);
    var list = document.createElement('ul');
    list.className = 'mm-search-catalog-matches';
    recovery.products.forEach(function (product) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      link.href = root + 'products/' + encodeURIComponent(product.handle);
      link.className = page ? 'mm-search-page-suggestion__link' : 'mm-search-suggestion__link';
      // Keep pickup restrictions in link text; they affect the buying decision.
      link.textContent = product.title + (product.available ? '' : ' — Sold out');
      link.dataset.productHandle = product.handle;
      link.dataset.productTitle = product.title;
      item.appendChild(link);
      list.appendChild(item);
    });
    panel.appendChild(list);
    scope.querySelectorAll('.search-flydown__no-results, .mh-search-flydown__no-results > p, .productgrid--no-results-title').forEach(function (empty) { empty.remove(); });
    scope.insertBefore(panel, scope.firstChild);
    return true;
  }

  function getDatasetValue(scope, key) {
    if (!scope || !scope.dataset) return '';
    return String(scope.dataset[key] || '').trim();
  }

  function getPredictiveListRoot(scope) {
    if (!scope) return null;
    return scope.querySelector('.search-flydown--product-items .search-flydown__group-list');
  }

  function getPredictiveItemTitle(item, card) {
    return cleanTitle(getDatasetValue(card, 'productTitle')) ||
      cleanTitle(item.querySelector('.search-flydown--product-title') && item.querySelector('.search-flydown--product-title').textContent);
  }

  function getPredictiveItemKey(item) {
    if (!item) return '';

    var card = item.querySelector(SEARCH_CARD_SELECTOR);
    var productId = getDatasetValue(card, 'productId');
    if (productId) return 'id:' + productId;

    var handle = getDatasetValue(card, 'productHandle');
    if (handle) return 'handle:' + normalizeText(handle);

    var link = item.querySelector('.search-flydown--product[href]');
    var href = link && link.getAttribute('href');
    if (href) {
      try {
        return 'path:' + new URL(href, window.location.origin).pathname.replace(/\/+$/, '').toLowerCase();
      } catch (error) {
        return 'path:' + href.split('?')[0].split('#')[0].replace(/\/+$/, '').toLowerCase();
      }
    }

    var title = getPredictiveItemTitle(item, card);
    return title ? 'title:' + normalizeText(title) : '';
  }

  function dedupePredictiveResults(scope) {
    var listRoot = getPredictiveListRoot(scope);
    if (!listRoot) return 0;

    var seen = new Set();
    var removed = 0;

    Array.from(listRoot.querySelectorAll('.search-flydown--product-list-item')).forEach(function (item) {
      var key = getPredictiveItemKey(item);
      if (!key) return;

      if (seen.has(key)) {
        item.remove();
        removed += 1;
        return;
      }

      seen.add(key);
    });

    return removed;
  }

  function rerankPredictiveResults(scope, query) {
    if (!scope || !query) return;

    var queryNormalized = normalizeText(query);
    var queryTokens = getTokens(queryNormalized);
    if (!queryTokens.length) return;

    dedupePredictiveResults(scope);

    var listRoot = getPredictiveListRoot(scope);
    if (!listRoot) return;

    var items = Array.from(listRoot.querySelectorAll('.search-flydown--product-list-item'));
    if (items.length < 2) return;

    var ranked = items
      .map(function (item, index) {
        var card = item.querySelector(SEARCH_CARD_SELECTOR);
        var title = getPredictiveItemTitle(item, card);
        var type = getDatasetValue(card, 'productType');
        var tags = getDatasetValue(card, 'productTags').replace(/,/g, ' ');
        var handle = getDatasetValue(card, 'productHandle').replace(/-/g, ' ');
        var score = scoreEntry(queryNormalized, queryTokens, {
          p: [
            normalizeText(title),
            normalizeText(type),
            normalizeText(tags),
            normalizeText(handle),
          ].filter(Boolean),
        });

        return {
          item: item,
          index: index,
          score: score,
        };
      })
      .sort(function (left, right) {
        if (right.score !== left.score) return right.score - left.score;
        return left.index - right.index;
      });

    ranked.forEach(function (entry) {
      listRoot.appendChild(entry.item);
    });
  }

  function clearPredictiveSuggestion(scope) {
    if (!scope) return;
    var existing = scope.querySelector('[data-mm-search-suggestion]');
    if (existing) existing.remove();
  }

  function simplifyEmptyPredictiveState(scope) {
    if (!scope) return;

    var noResults = scope.querySelector('.search-flydown__no-results');
    if (noResults) noResults.remove();

    var continueButton = scope.querySelector('.search-flydown__continue');
    if (continueButton) continueButton.remove();
  }

  function injectPredictiveSuggestion(scope, options) {
    if (!scope || !options || !options.correctedQuery) return;

    clearPredictiveSuggestion(scope);

    var isEmptyResults = Boolean(options.emptyResults);
    var displayQuery = String(options.originalQuery || options.correctedQuery || '').trim();

    if (isEmptyResults) {
      simplifyEmptyPredictiveState(scope);
    }

    var banner = document.createElement('div');
    banner.className = 'mm-search-suggestion' + (isEmptyResults ? ' mm-search-suggestion--empty' : '');
    banner.setAttribute('data-mm-search-suggestion', '');

    var text = document.createElement('span');
    text.className = 'mm-search-suggestion__text';

    if (isEmptyResults) {
      text.textContent = displayQuery
        ? 'No available products found for "' + displayQuery + '".'
        : 'No available products found.';
    } else {
      text.textContent = 'Showing closest matches for "' + options.correctedQuery + '".';
    }

    var link = document.createElement('a');
    link.className = 'mm-search-suggestion__link';
    link.href = getSearchUrl(isEmptyResults ? displayQuery : options.correctedQuery);
    link.textContent = isEmptyResults ? 'Search all results' : 'View search results';
    if (isEmptyResults && displayQuery) {
      link.setAttribute('aria-label', 'Search all results for "' + displayQuery + '"');
    }

    banner.appendChild(text);

    if (isEmptyResults && normalizeText(options.correctedQuery) !== normalizeText(displayQuery)) {
      var helper = document.createElement('span');
      helper.className = 'mm-search-suggestion__helper';
      helper.textContent = 'Closest catalog match: ' + options.correctedQuery + ', but it is not available right now.';
      banner.appendChild(helper);
    }

    banner.appendChild(link);

    if (!isEmptyResults && options.originalQuery) {
      var originalLink = document.createElement('a');
      originalLink.className = 'mm-search-suggestion__link mm-search-suggestion__link--muted';
      originalLink.href = getSearchUrl(options.originalQuery);
      originalLink.textContent = 'Search instead for "' + options.originalQuery + '"';
      banner.appendChild(originalLink);
    }

    scope.insertBefore(banner, scope.firstChild);
  }

  function normalizeLuckyUrl(value) {
    var rawValue = String(value || '').trim();
    if (!rawValue || rawValue.charAt(0) === '#') return '';

    try {
      var baseOrigin = window.location.origin && window.location.origin !== 'null'
        ? window.location.origin
        : 'https://mrmaple.local';
      var url = new URL(rawValue, baseOrigin);
      if (url.origin !== baseOrigin) return '';
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return '';
    }
  }

  function getLuckyUrls(link) {
    if (!link) return [];

    var seen = new Set();
    var urls = String(link.getAttribute('data-search-lucky-urls') || '')
      .split('|')
      .map(normalizeLuckyUrl)
      .filter(function (url) {
        if (!url || seen.has(url)) return false;
        seen.add(url);
        return true;
      });

    if (!urls.length) {
      var fallbackUrl = normalizeLuckyUrl(link.getAttribute('href'));
      if (fallbackUrl) urls.push(fallbackUrl);
    }

    return urls;
  }

  function primeSearchLuckyLink(target) {
    var link = target && target.closest ? target.closest('[data-search-lucky-link]') : null;
    if (!link) return '';

    var urls = getLuckyUrls(link);
    if (!urls.length) return '';

    var currentUrl = normalizeLuckyUrl(link.getAttribute('href'));
    var candidates = urls.length > 1
      ? urls.filter(function (url) { return url !== currentUrl; })
      : urls;
    var selectedUrl = candidates[Math.floor(Math.random() * candidates.length)] || urls[0];

    link.setAttribute('href', selectedUrl);
    return selectedUrl;
  }

  function initSearchLuckyLinks() {
    var handler = function (event) {
      primeSearchLuckyLink(event.target);
    };

    document.addEventListener('pointerover', handler, true);
    document.addEventListener('focusin', handler, true);
    document.addEventListener('click', handler, true);
  }

  async function initSearchPageSuggestion() {
    if (!document.body || !document.body.classList.contains(SEARCH_PAGE_CLASS)) return;
    var params = new URLSearchParams(window.location.search);
    // Respect explicit categories, facets and later pages instead of bypassing them.
    if (params.get('page') && params.get('page') !== '1') return;
    if (params.get('type') && params.get('type').split(',').indexOf('product') === -1) return;
    if (Array.from(params.keys()).some(function (key) { return key.indexOf('filter.') === 0; })) return;
    var query = params.get('q') || '';
    if (!query.trim() || /(?:tag|product_type):/.test(query)) return;
    var scope = document.querySelector('[data-search-results-panel]') || document.querySelector('.productgrid--no-results');
    if (!scope || scope.querySelector('[data-search-catalog-matches]')) return;
    var location = window.location.href;
    var recovery = await getCatalogRecovery(query, scope);
    if (window.location.href !== location || !scope.isConnected) return;
    appendCatalogLinks(scope, recovery, query, true);
    if (scope.querySelector('.productgrid--items') && !hasRelevantProductMatches(scope, query)) {
      var note = document.createElement('p');
      note.className = 'mm-search-page-suggestion__helper';
      note.textContent = 'No close name matches found. These results may be related to your search.';
      scope.insertBefore(note, scope.firstChild);
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
      return;
    }

    fn();
  }

  window.MrMapleSearchIntelligence = {
    cleanTitle: cleanTitle,
    normalizeText: normalizeText,
    getSearchUrl: getSearchUrl,
    getRankedSearchPageUrl: getRankedSearchPageUrl,
    normalizeSearchPageUrl: normalizeSearchPageUrl,
    loadIndex: loadIndex,
    findSuggestion: findSuggestion,
    findCatalogMatch: findCatalogMatch,
    getCatalogRecovery: getCatalogRecovery,
    appendCatalogLinks: appendCatalogLinks,
    hasRelevantProductMatches: hasRelevantProductMatches,
    hasProductMatches: hasProductMatches,
    dedupePredictiveResults: dedupePredictiveResults,
    rerankPredictiveResults: rerankPredictiveResults,
    clearPredictiveSuggestion: clearPredictiveSuggestion,
    injectPredictiveSuggestion: injectPredictiveSuggestion,
    initSearchPageSuggestion: initSearchPageSuggestion,
    primeSearchLuckyLink: primeSearchLuckyLink,
  };

  ready(function () {
    if (normalizeSearchPageUrl()) return;

    initSearchLuckyLinks();
    initSearchPageSuggestion();
  });
})();
